// extracted by mini-css-extract-plugin
export default {"modalToaster":"customToaster_modalToaster__r2-vx"};